import { defineMessages } from 'react-intl';

export default defineMessages({
    wantToDelete: {
        "id": "twia.translation.ConstructionDetails.wantToDelete",
        "defaultMessage": "Remove Roofing Update"
    },
    roofingCancelMessage: {
        "id": "twia.translation.ConstructionDetails.cancelMessage",
        "defaultMessage": "Are you sure you want to remove this roofing update?"
    },
    repairCancelMessage: {
        "id": "twia.translation.ConstructionDetails.repairCancelMessage",
        "defaultMessage": "Are you sure you want to remove this Repair/Addition?"
    },
    wantToDeleteRepair: {
        "id": "twia.translation.ConstructionDetails.wantToDeleteRepair",
        "defaultMessage": "Remove Repair/Addition"
    },
    yesModal: {
        "id": "twia.translation.ConstructionDetails.Yes",
        "defaultMessage": "Yes"
    },
    closeModal: {
        "id": "twia.translation.ConstructionDetails.Close",
        "defaultMessage": "Close"
    },
    cancelModal: {
        "id": "twia.translation.ConstructionDetails.Cancel",
        "defaultMessage": "Cancel"
    },
    noModal: {
        "id": "twia.translation.ConstructionDetails.No",
        "defaultMessage": "No"
    },
    roofingAlert: {
        "id": "twia.translation.ConstructionDetails.Roofing Alert",
        "defaultMessage": "Unable to Deselect Roofing Updates"
    },
    repairAlert: {
        "id": "twia.translation.ConstructionDetails.Repair Alert",
        "defaultMessage": "Unable to Deselect Repairs/Additions"
    },
    alertMessage: {
        "id": "twia.translation.ConstructionDetails.Alert Message",
        "defaultMessage": "You must remove all the Roofing Updates records in order to uncheck this box."
    },
    repairAlertMessage: {
        "id": "twia.translation.ConstructionDetails.Repair Alert Message",
        "defaultMessage": "You must remove all the Repairs/Additions records in order to uncheck this box."
    },
    // DE15522, DE15831
    roofingUpdatesMH: {
        "id": "twia.quoteandbind.views.Roofing Updates Manufactured Home",
        "defaultMessage": "Added Living Space Roofing Updates"
    },
    roofingUpdates: {
        "id": "twia.quoteandbind.views.Roofing Updates",
        "defaultMessage": "Roofing Updates"
    },
    roofingUpdatesTFPA: {
        "id": "tfpa.quoteandbind.views.Roofing Updates",
        "defaultMessage": "Roofing Updated"
    },
    // label change for Manufactured Home
    repairsMH: {
        "id": "twia.quoteandbind.views.Repairs/Additions Manufactured Home",
        "defaultMessage": "Added Living Space Repairs/Additions"
    },
    repairs: {
        "id": "twia.quoteandbind.views.Repairs/Additions",
        "defaultMessage": "Repairs/Additions"
    },
    dateMustmatch: {
        id: 'twia.quoteandbind.views.Please enter a valid date (MM/DD/YYYY)',
        defaultMessage : 'Please enter a valid date (MM/DD/YYYY).'
    }
})
